import { z } from "zod";

export const lastName = z
  .string()
  .min(2, { error: "Last Name must be at least 2 characters" });
